export default {
  image: 'A3_1_2.png',
  pdf: '220922_WA-EPS_002_A3_1_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-EPS-002',
    technicalValues: {
      soundReductionIndex: {
        output: '48,4',
        value: 48.4
      },
      heatTransferCoefficient: {
        output: '0,12',
        value: 0.12
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 60-B',
        value: 'F-60-B'
      },
      fireResistanceInner: {
        output: 'F 60-B',
        value: 'F-60-B'
      }
    },
    name: 'Wandaufbau mit EPS l Aufbau 2',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '140 mm Sto-Dämmplatte Top 32',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'pda-140'
        },
        {
          output: '2 x 12,5 mm Gipsfaserplatten',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-25'
        },
        {
          output: '≥ 60/160',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-160'
        },
        {
          output: '160 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-160'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'io-12'
        },
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '355,5',
        value: 355.5
      }
    }
  }
}
